<template>
  <div id="mapEchart">
    <chart :cdata="screenData"></chart>
  </div>
</template>

<script>
import chart from "./chart";
export default {
  props: {
    screenData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    screenData: {
      handler: function (newData) {
        this.screenData = newData;
      },
      immediate: true,
      deep: true, //深度监听设置为 true
    },
  },
  data() {
    return {
      cdata: {
        geoCoordMap: {},
        HZData: [],
      },
      regionList: [],
    };
  },
  components: {
    chart,
  },
  mounted() {
    // this.queryRegion();
  },
  methods: {
    // async queryDict(type, namespace) {
    //   let data = {
    //     url: "http://CORE-COMMON/messageService/dictService/queryEntries",
    //     body: { type: type, namespace: namespace },
    //   };
    //   var list = await this.invoke(data);
    //   return list;
    // },
    // async queryRegion() {
    //   this.regionList = await this.queryDict("fullArea", "region");
    // },
    // findDictName(list, code) {
    //   const result = list.find((item) => item.code === code);
    //   return result.text;
    // },
  },
};
</script>

<style lang="scss" scoped>
#mapEchart {
  height: 100%;
  width: 100%;
  color: #fb6a8796;
}
</style>